import type { AdminTabValue } from './AdminLayout';

export const RESTRICTED_ADMIN_TABS = [
  'team',
  'ai',
  'debug',
  'announcements',
  'reports',
  'quotes',
  'api-keys',
] as const;

export type RestrictedAdminTab = (typeof RESTRICTED_ADMIN_TABS)[number];

export type AdminNavAccess = Partial<Record<RestrictedAdminTab, boolean>>;

const restrictedTabSet = new Set<AdminTabValue>(RESTRICTED_ADMIN_TABS);

export const isSuperAdminEmail = (email?: string | null): boolean =>
  (email || '').trim().toLowerCase() === 'bryce@honeydone.com';

export const normalizeAdminNavAccess = (value: unknown): AdminNavAccess => {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return {};
  }

  const access: AdminNavAccess = {};
  for (const tab of RESTRICTED_ADMIN_TABS) {
    const rawValue = (value as Record<string, unknown>)[tab];
    if (typeof rawValue === 'boolean') {
      access[tab] = rawValue;
    }
  }

  return access;
};

export const hasAdminTabAccess = (
  tab: AdminTabValue,
  adminNavAccess: AdminNavAccess,
  isSuperAdmin: boolean
): boolean => {
  if (!restrictedTabSet.has(tab)) {
    return true;
  }

  void isSuperAdmin;

  return adminNavAccess[tab as RestrictedAdminTab] === true;
};
